<template>
  <div style="margin-top:30px">
    <el-form ref="form" :model="reuuest" label-width="100px" disabled="disabled">
      <el-row>
        <div class="grid-content bg-purple">
          <el-form-item label="货物大类" prop="cargoName" style="margin-right:15px">
            <el-input v-model="reuuest.cargoLargeClassName" placeholder="请输入货物名称" />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item label="货物名称" prop="cargoName" style="margin-right:15px">
            <el-input v-model="reuuest.cargoName" placeholder="请输入货物名称" />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item label="货物数量" prop="cargoNumber" style="margin-right:15px">
            <el-input v-model="reuuest.cargoNumber" placeholder="" />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item label="货物数量单位" prop="cargoNumberCompany" style="margin-right:15px">
            <el-input v-model="reuuest.cargoNumberCompany" placeholder="" />
          </el-form-item>
        </div>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'DiyReportEdit',
  data() {
    return {
      emptyForm: {},
      form: {
        code: ''

      },
      reuuest: {
        code: ''

      },
      rules: {
        name: [
          { required: true, message: '请输入报表名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择报表类型', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    getInfo(cardNo) {
      this.form.code = cardNo
      request({
        url: `/ntocc-ctms-api/ctmsOrderDetail/getctmsOrderDetail/` + cardNo,
        method: 'GET'
      }).then(response => {
        this.reuuest = response.data
      }).catch((error) => {
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin:15px 0 15px 0;
    width: 175px;
    float: right;
  }
  .el-select {
    width: 100%;
  }
</style>
